import { render, staticRenderFns } from "./god.vue?vue&type=template&id=6af14c94&scoped=true&"
import script from "./god.vue?vue&type=script&lang=js&"
export * from "./god.vue?vue&type=script&lang=js&"
import style0 from "./god.vue?vue&type=style&index=0&id=6af14c94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6af14c94",
  null
  
)

export default component.exports